<div class="contact" (click)="selectEntry()">
  <label>name:</label> {{contact?.name}}<br>
  <label>address:</label> {{contact?.address}}<br>
</div>
